import Layout from '@layout/Index'

export const auditTask = [
  {
    path: '/audit-task',
    component: Layout,
    children: [
      {
        path: '',
        redirect: 'table',
      },
      {
        path: 'table',
        component: () => import(/* webpackChunkName: "audit-task-table" */ './pages/AuditTaskTable.vue'),
        name: '审单管理',
        meta: {
          title: '审单管理',
        },
      },
    ],
  },
]




// WEBPACK FOOTER //
// ./src/views/audit-task/audit-task.route.js